import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { useParams } from 'react-router-dom';

const ReportInput = () => {
  const { reportId = '' } = useParams();
  const decodedId = reportId ? atob(reportId) : reportId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'report';

  useEffect(() => {
    if (reportId) { setIsEditing(true); fetchDetails(); }
  }, [reportId]);

  const fetchDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.report}${id}/`, { headers });
      setFormData(response.data);
    } catch (error) {
      console.error('Error fetching report details:', error);
    }
  };

  const fields = [
    { name: 'name', label: 'Report Name', type: 'text' },
    { name: 'description', label: 'Description', type: 'textarea' },
    {
      name: 'report_type', label: 'Report Type', type: 'select',
      options: [
        { value: 'sales_pipeline', label: 'Sales Pipeline' },
        { value: 'revenue', label: 'Revenue' },
        { value: 'lead_conversion', label: 'Lead Conversion' },
        { value: 'activity_summary', label: 'Activity Summary' },
        { value: 'customer_engagement', label: 'Customer Engagement' },
        { value: 'forecast', label: 'Forecast' },
        { value: 'performance', label: 'Performance' },
        { value: 'custom', label: 'Custom' },
      ],
    },
    {
      name: 'frequency', label: 'Frequency', type: 'select',
      options: [
        { value: 'one_time', label: 'One Time' },
        { value: 'daily', label: 'Daily' },
        { value: 'weekly', label: 'Weekly' },
        { value: 'monthly', label: 'Monthly' },
        { value: 'quarterly', label: 'Quarterly' },
      ],
    },
    {
      name: 'output_format', label: 'Output Format', type: 'select',
      options: [
        { value: 'pdf', label: 'PDF' },
        { value: 'excel', label: 'Excel' },
        { value: 'csv', label: 'CSV' },
        { value: 'html', label: 'HTML' },
      ],
    },
    { name: 'is_public', label: 'Public Report', type: 'checkbox' },
    { name: 'filters', label: 'Filters (JSON)', type: 'textarea' },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Report' : 'Create Report'}</h1>
      <FormComponent fields={fields} initialFormData={formData} route={route} />
    </div>
  );
};

export default ReportInput;
